window.dataLayer = window.dataLayer || [];
function gtag(){ dataLayer.push(arguments); }

// GCM v2 — default denial must fire before GA4 initialises via content_for_header
gtag('consent', 'default', {
  analytics_storage: 'denied',
  ad_storage: 'denied',
  ad_user_data: 'denied',
  ad_personalization: 'denied',
  wait_for_update: 2000
});

// Restore consent synchronously for returning visitors
// stored.v is only compared, never rendered to DOM
(function () {
  try {
    var stored = JSON.parse(localStorage.getItem('rp_consent') || 'null');
    if (stored && stored.value === 'accepted') {
      gtag('consent', 'update', {
        analytics_storage: 'granted',
        ad_storage: 'granted',
        ad_user_data: 'granted',
        ad_personalization: 'granted'
      });
    }
  } catch (e) {}
})();
